import React, { Component } from 'react';
import { Modal, Tabs, Spin, message } from 'antd';
import FteRequirement from './FteRequirement';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import { RequirementInfo } from '../constants';
import moment from 'moment';

const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';
const config = {
    title: '调整需求',
};

class AdjustRequirement extends Component {
    constructor(props) {
        super(props);
        this.noFte = false;
        this.isAsh = false;
        this.record = {};
        this.state = {
            visible: false,
            loading: false,
            termination: '',
            activeKey: '',
            panes: []
        };
    }

    loadData = () => {
        const { requirementId } = this.record;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.member.getAssignedUserFteList,
            data: { requirementId },
            doneResult: res => {
                const { data, termination } = res;
                const panes = this.parseData(data);
                const activeKey = (panes[0] && panes[0].userId) || '';
                this.setState({
                    panes,
                    activeKey,
                    termination,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    show = (record) => {
        this.record = record;
        this.setState({
            visible: true,
            activeKey: 1,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    parseData = (data) => {
        return (data || []).map(item => {
            const { userId, userCompellation, canEdit } = item;
            const params = {
                userId: userId + '',
                userName: userCompellation,
                requirementInfo: this.genRequirementInfo(item),
                canEdit: canEdit !== false,
            };
            this.initialDate(params.requirementInfo);
            return params;
        });
    }

    genRequirementInfo = (data) => {
        const result = {};
        Object.keys(RequirementInfo).forEach(key => {
            const item = data[key];
            if (item) {
                const { requirementId, sourceRequirementId, detailList } = item;
                const fteList = (detailList || []).map(i => ([format('month', i.year, i.month), i.planFte]));
                result[key] = {
                    sourceRequirementId,
                    requirementId,
                    fteList
                };
            }
        });
        return result;
    }

    initialDate = (requirementInfo) => {
        const { planEndTime } = this.props;
        const startMonth = moment().format(monthFormat);
        const endMonth = moment(planEndTime).format(monthFormat);

        Object.keys(requirementInfo || {}).forEach(key => {
            requirementInfo[key].startMonth = startMonth;
            requirementInfo[key].endMonth = endMonth;
        });
    }

    handleChange = (value, key, index, type) => {
        const { panes } = this.state;
        panes[index].requirementInfo[type][key] = value;
        this.setState({ panes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    confirm = () => {
        const { panes } = this.state;

        let params = {};
        for (let n = 0, len = panes.length; n < len; n++) {
            const { userId, requirementInfo } = panes[n];
            const requirementInfoKeys = Object.keys(requirementInfo);
            for (let key of requirementInfoKeys) {
                const { requirementId, sourceRequirementId, fteList } = requirementInfo[key] || {};
                if (!(fteList || []).length) {
                    return message.warning('请填写FTE需求!');
                } else {
                    for (let i = 0, len = fteList.length; i < len; i++) {
                        const [ date, fte ] = fteList[i];
                        if (!date || (!fte && fte !== 0)) {
                            return message.warning('请将FTE填写完整!');
                        }
                        params[`userList[${n}].${key}.fteList[${i}].year`] = moment(date).format("YYYY");
                        params[`userList[${n}].${key}.fteList[${i}].month`] = moment(date).format("MM");
                        params[`userList[${n}].${key}.fteList[${i}].fte`] = fte;
                    }
                }
                params[`userList[${n}].${key}.userId`] = userId;
                params[`userList[${n}].${key}.requirementId`] = requirementId;
                params[`userList[${n}].${key}.sourceRequirementId`] = sourceRequirementId;
            }
        }

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.member.changeRequirement,
            data: params,
            doneResult: res => {
                message.success(res.data.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
        };
        $.sendRequest(options);
    }

    getTabContent = (pane, index) => {
        const { activeKey, termination } = this.state;
        const { userId, canEdit, requirementInfo } = pane;
        if (userId == activeKey) {
            const { planBeginTime, planEndTime } = this.props;
            const params = {
                canEdit,
                termination,
                noFte: this.noFte,
                isAsh: this.isAsh,
                planBeginTim: planBeginTime,
                planEndTime: planEndTime,
            };
            const requirementInfoKeys = Object.keys(requirementInfo);

            return (
                requirementInfoKeys.map((item, i, array) => (
                    <div key={item}>
                        { array.length > 1 && <div style={{paddingLeft:12,lineHeight:'28px',backgroundColor:'#FAFAFA'}}>{RequirementInfo[item]}</div> }
                        <FteRequirement
                            asterisk={false}
                            params={params}
                            isChange={true}
                            data={requirementInfo[item]}
                            onChange={(value, key) => this.handleChange(value, key, index, item)}
                        />
                    </div>
                ))
            );
        }
    }

    getTabsContent = () => {
        const { panes, activeKey } = this.state;
        return (
            <Tabs activeKey={activeKey} onChange={this.handleTabsChange}>
                {panes.map((pane, index) => <TabPane tab={pane.userName} key={pane.userId}>{this.getTabContent(pane, index)}</TabPane>)}
            </Tabs>
        );
    }

    getContent = () => {
        const { investigationSiteName, investigationSiteCode, city ,courtyardArea,departmentName} = this.record;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">中心名称(中心编号):</div>
                    <div className="item-right">{format('joint', investigationSiteName, investigationSiteCode, 'roundBrackets')}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">院区:</div>
                    <div className="item-right">{courtyardArea}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">科室:</div>
                    <div className="item-right">{departmentName}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">城市:</div>
                    <div className="item-right">{city}</div>
                </li>
                {this.getTabsContent()}
            </ul>
        );
    }

    render() {
        const { loading, visible } = this.state;
        return (
            <Modal
                title={config.title}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                width="600px"
                maskClosable={false}
                bodyStyle={{ maxHeight: 500 }}
            >
                <Spin spinning={loading}>
                    <div className="modal-content form-list" style={{padding: 0}}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default AdjustRequirement;


// WEBPACK FOOTER //
// ./src/components/user/require/components/AdjustRequirement.js